<template>
  <v-row>
    <v-col cols="12" sm="12">
      <TitleAndSearch
        :icon="'icon_person_groups'"
        :title="$t('fleet_management.person_groups.person_groups_table.page_title')"
        :showSearch="showSearch"
        :id-input-search="'idGruposDePersonasBuscar'"
      />
      <v-row>
        <v-col cols="12">
          <PersonGroupsDataTable />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import TitleAndSearch from '@/components/TitleAndSearch.vue';
import PersonGroupsDataTable from '@/components/personGroups/DataTable.vue';
export default {
  name: 'PersonGroupsView',
  components: {
    TitleAndSearch,
    PersonGroupsDataTable
  },
  data() {
    return {
      showSearch: true
    }
  },
  methods: {
    showSearchInput() {
      const currentRoute = this.$router.currentRoute;
      if (currentRoute.name !== 'PersonGroupsList') this.showSearch = false;
      else this.showSearch = true;
    }
  },
  created() {
    this.showSearchInput();
  },
  updated() {
    this.showSearchInput();
  }
}
</script>

<style></style>
